<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="checkbox" label="区域类型" name="region_type" :options="regionType" ></c-form-item>
					<c-form-item type="input" label="区域名称" name="region_name"></c-form-item>
					<c-form-item type="input" label="负责人昵称" name="manager_nick_name"></c-form-item>
					<c-form-item type="input" label="负责人手机" name="manager_mobilephone"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="begin_time" end-name="end_time"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="区域类型"
					name="region_type"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.region_type==1" style="color:darkgreen">省级</span>
						<span v-if="data.region_type==2" style="color:brown">市级</span>
						<span v-if="data.region_type==3">区县级</span>
					</template>
				</c-table-column>

				<c-table-column
					label="区域名称"
					name="region_name"
					width="100"
				></c-table-column>

				<c-table-column
					label="区域负责人"
					name="region_name"
					width="220"
				>
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<c-image v-if="data.manager_user_id > 0" :src="data.manager_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
							<span v-if="data.manager_user_id > 0">
								{{data.manager_nick_name}}
								<span v-if="data.manager_mobilephone">({{data.manager_mobilephone}})</span>
							</span>
						</div>
					</template>
				</c-table-column>

				<c-table-column
					label="付款时间"
					name="payment_date"
					width="140"
				></c-table-column>

				<c-table-column
					label="订单号"
					name="order_number"
					width="120"
				></c-table-column>

				<c-table-column
					label="商品数量"
					name="product_count"
					width="80"
				></c-table-column>

				<c-table-column
					label="分红单价"
					name="subsidy_money"
					width="80"
				>
          <template v-slot="row">
            {{'¥'+parseFloat(row.data.subsidy_money).toFixed(2)}}
          </template>
        </c-table-column>

				<c-table-column
					label="分红金额"
					name="subsidy_total_money"
					width="200"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.subsidy_total_money).toFixed(2)}}
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_region_dividend',
		
		data() {
			return {
				regionType: [{
					name: '省级',
					value: 1
				},{
					name: '市级',
					value: 2
				},{
					name: '区县级',
					value: 3
				}]
			}
		},
		
		mounted() {
			  this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/platform_user/region/dividend/list',
					data
				});
			}
		}
	}
</script>